module.exports = __webpack_public_path__ + "static/media/login_gif_extended.f3be9d73.gif";